import { AppLayout } from '@/components/layout/app-layout'
import { MobileAppLayout } from '@/components/layout/mobile-app-layout'
import { useIsMobileContext } from '@/components/layout/responsive-layout'

export function LayoutSelector() {
  const isMobile = useIsMobileContext()
  return isMobile ? <MobileAppLayout /> : <AppLayout />
}
